/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RestoreSubscriptionRequestBody
 */
export interface RestoreSubscriptionRequestBody {
    /**
     * 
     * @type {number}
     * @memberof RestoreSubscriptionRequestBody
     */
    trialDays: number;
}

/**
 * Check if a given object implements the RestoreSubscriptionRequestBody interface.
 */
export function instanceOfRestoreSubscriptionRequestBody(value: object): value is RestoreSubscriptionRequestBody {
    if (!('trialDays' in value) || value['trialDays'] === undefined) return false;
    return true;
}

export function RestoreSubscriptionRequestBodyFromJSON(json: any): RestoreSubscriptionRequestBody {
    return RestoreSubscriptionRequestBodyFromJSONTyped(json, false);
}

export function RestoreSubscriptionRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RestoreSubscriptionRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'trialDays': json['trialDays'],
    };
}

export function RestoreSubscriptionRequestBodyToJSON(json: any): RestoreSubscriptionRequestBody {
    return RestoreSubscriptionRequestBodyToJSONTyped(json, false);
}

export function RestoreSubscriptionRequestBodyToJSONTyped(value?: RestoreSubscriptionRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trialDays': value['trialDays'],
    };
}

